import * as React from "react";

const TBCIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // Tight viewBox around the icon (removes the extra space on the right)
    viewBox="410 908.518 2139.104 1907.887"
    width={20}
    height={20}
    {...props}
  >
    <g transform="translate(431.59018,908.72923)" fill="#00a3e0">
      <path d="m 946,1055 c 9,90 14,136 -59,213 -76,80 -266,227 -460,339 -82,48 -193,105 -277,135 -62,23 -114,32 -140,-13 -17,-29 -9,-56 0,-79 68,-183 262,-526 389,-748 13,-23 27,-46 40,-70 C 635,495 894,82 945,16 952,6 966,-5 978,2 c 10,6 10,18 9,27 0,1 -3,13 -5,18 -83,341 -74,675 -36,1008 z" />
      <path d="m 1232,1160 c -82,-38 -125,-57 -155,-159 -31,-105 -64,-343 -64,-568 0,-94 6,-218 21,-306 12,-66 30,-116 82,-116 34,0 53,21 69,40 125,150 323,490 453,712 13,22 26,45 40,69 194,338 422,769 454,846 5,11 8,28 -5,36 -10,5 -20,-1 -27,-6 -1,-1 -10,-10 -13,-13 -254,-243 -547,-402 -855,-535 z" />
      <path d="m 998,1354 c 74,-52 112,-79 215,-55 106,26 329,117 524,229 81,47 186,115 255,172 50,43 85,83 59,128 -17,29 -44,36 -69,40 -193,33 -587,35 -843,37 -26,0 -53,0 -80,0 -390,-1 -877,-19 -960,-30 -12,-1 -28,-7 -28,-22 0,-11 10,-18 18,-21 2,0 14,-4 18,-5 337,-98 622,-272 891,-473 z" />
    </g>
  </svg>
);

export default TBCIcon;
